module.exports = __webpack_public_path__ + "img/5_64.773b740f.png";